import React from 'react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { roles } from '../data/site';
export function Experience() {
  return <>
      <PageHeader eyebrow="Featured Roles & Key Impact" title="Two decades operating at the executive edge of care delivery." description="Enterprise quality, academic emergency medicine operations, clinical AI product leadership, and venture advisory." data-id="element-145" data-mp="ahnnuxarii6q" />

      <section className="w-full bg-ivory py-20 lg:py-24" data-id="element-146" data-mp="39x12u87wuwlk">
        <div className="mx-auto max-w-5xl px-6 lg:px-10" data-id="element-147" data-mp="39yly6021ujkh">
          <ol className="border-l border-stone" data-id="element-148" data-mp="3noz4xz37fs88">
            {roles.map((role, i) => <motion.li key={role.title} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-70px'
          }} transition={{
            duration: 0.4,
            delay: i * 0.06
          }} className="relative pb-10 pl-8 last:pb-0 sm:pl-12" data-id="element-149" data-mp="3ixz9yzdnbk8d" data-mpi={i}>
                <span className="absolute -left-[7px] top-2 h-3.5 w-3.5 border-2 border-ink-950 bg-ivory" aria-hidden="true" data-id="element-150" data-mp="3j205dez9gs3f" />
                <article className="bg-white p-7 transition-shadow hover:shadow-[0_16px_40px_-24px_rgba(11,23,35,0.5)] lg:p-9" data-id="element-151" data-mp="3stebi5lpwq5j">
                  <div className="flex flex-wrap items-center gap-3" data-id="element-152" data-mp="1nv1d6zd0yy5">
                    <span className="border border-ink-950/15 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.18em] text-ink-900" data-id="element-153" data-mp="304yvbfquo1sm">
                      {role.period}
                    </span>
                    <span className="text-[12px] font-semibold uppercase tracking-[0.14em] text-brass-500" data-id="element-154" data-mp="3a00msi8llfyd">
                      {role.org}
                    </span>
                  </div>
                  <h2 className="mt-4 font-display text-xl leading-snug text-ink-950" data-id="element-155" data-mp="pal0o0kbqff2">
                    {role.title}
                  </h2>
                  <p className="mt-3 text-[15px] leading-relaxed text-graphite" data-id="element-156" data-mp="2qdkfh9s0335e">
                    {role.body}
                  </p>
                  <ul className="mt-5 flex flex-wrap gap-2" data-id="element-157" data-mp="2lfalv3lxcalw">
                    {role.tags.map(tag => <li key={tag} className="bg-ivory px-3 py-1.5 text-[12px] font-medium text-ink-900" data-id="element-158" data-mp="2zcz4e4sir5ns">
                        {tag}
                      </li>)}
                  </ul>
                </article>
              </motion.li>)}
          </ol>
        </div>
      </section>
    </>;
}